<template>
    <div class="template-connected">
      <div id="container">
        <div v-if="userConnected.roles.includes('ROLE_SUPER_ADMIN')" class="block-flat">
          <div class="block-content">
            <fieldset>
              <legend>
                <b-row>
                  <b-col cols="2"> Messages </b-col>
                  <b-col cols="10" class="text-right">
                    <b-button
                      class="ml-5 mb-1"
                      variant="success"
                      @click="saveMessages(myMessages)"
                      ><font-awesome-icon
                        icon="save"
                        class="mr-2"
                      ></font-awesome-icon
                      >Sauvegarder</b-button
                    >
                  </b-col>
                </b-row>
              </legend>
            </fieldset>
            <b-row>
              <b-col cols="12" class="text-center">
                <b-button variant="success" @click="handleAdd()"
                  >Ajouter un message</b-button
                >
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" class="text-center">
                <b-editable-table
                  bordered
                  class="editable-table w-100"
                  v-model="myMessages"
                  @input-change="handleInput"
                  :fields="fields"
                >
                  <template #cell(visible)="data">
                    <span v-if="data.value">Oui</span>
                    <span v-else>Non</span>
                  </template>
                  <template #cell(user)="data" class="text-center">
                    <span v-if="data.item.id != null">{{
                      data.item.stdUser.email
                    }}</span>
                    <span v-else> {{ userConnected.email }} </span>
                  </template>
                  <template #cell(delete)="data" class="text-center">
                    <b-button @click="handleDelete(data)"
                      ><font-awesome-icon icon="trash"></font-awesome-icon
                    ></b-button>
                  </template>
                </b-editable-table>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  
<script>
import BEditableTable from "bootstrap-vue-editable-table";
import Vuex from "vuex";

export default {
    components: {
        BEditableTable,
    },
    data: () => ({}),
    async mounted() {
        let messages = await this.getMessages();
    },

    methods: {
        handleInput(value, data) {},
        handleAdd() {
        this.myMessages.push({
            id: null,
            message: "Message",
            type: "info",
            visible: false,
        });
        },
        handleDelete(data) {
        const item = data.item;
        if (item && item.id !== null && item.id !== undefined) {
            this.deleteMessage(item.id).then(() => {
                this.myMessages.splice(data.index, 1);
            });
        } else {
            this.myMessages.splice(data.index, 1);
        }
        },
        ...Vuex.mapActions("BroadCastMessage", [
        "getMessages",
        "setMessages",
        "saveMessages",
        "deleteMessage",
        ]),
    },
    computed: {
        fields() {
        let tab = [];
        tab.push({
            key: "message",
            label: "Message",
            type: "text",
            editable: true,
        });
        tab.push({
            key: "type",
            label: "Couleur",
            type: "select",
            editable: true,
            class: "department-col",
            options: [
            { value: "success", text: "Vert" },
            { value: "info", text: "bleu" },
            { value: "warning", text: "Jaune" },
            { value: "danger", text: "Rouge" },
            ],
        });
        tab.push({
            key: "visible",
            label: "Visible ?",
            type: "checkbox",
            editable: true,
            class: "is-active-col",
        });
        tab.push({
            key: "createdAt",
            label: "Date de création",
            editable: false,
            type: "date",
            class: "name-col",
        });
        tab.push({ key: "user", label: "Crée par", class: "user-col" });
        tab.push({ key: "delete", label: "", class: "delete-col" });
        return tab;
        },
        myMessages: {
        get() {
            return this.messages;
        },
        set(value) {
            this.setMessages(value);
        },
        },
        ...Vuex.mapGetters("Authentification", ["userConnected", "drawerStatus"]),
        ...Vuex.mapGetters("BroadCastMessage", ["messages"]),
    },
};
</script>